import fr from "@/lib/i18n/pages.fr";
import ar from "@/lib/i18n/pages.ar";
import hmn from "@/lib/i18n/pages.hmn";

const PAGES = { fr, ar, hmn };

export const pageText = (lang, name) => PAGES[lang]?.[name];
